import { render, staticRenderFns } from "./TokenList.vue?vue&type=template&id=7bf986c6&scoped=true&"
import script from "./TokenList.vue?vue&type=script&lang=js&"
export * from "./TokenList.vue?vue&type=script&lang=js&"
import style0 from "./TokenList.vue?vue&type=style&index=0&id=7bf986c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bf986c6",
  null
  
)

export default component.exports